import { pdfjs } from 'react-pdf';

// Bundle the pdf.js worker (must match the single pdfjs-dist version — see the
// root pnpm override pinning pdfjs-dist to react-pdf's version).
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();
